import { isProduction } from '../../config/env';

// For more information please follow this link https://wework.slack.com/archives/C06620X7GKD/p1701781440819359?thread_ts=1701726471.266699&cid=C06620X7GKD
export const LOCATION_UUID = isProduction
  ? 'a1ea45dc-4123-466d-a5b8-9558dde6a767'
  : 'fabf963a-fb87-4c85-a62f-8d3102979004';
export const LOCATION_TIME_ZONE = 'America/New_York';

export const DEBOUNCE_DURATION = 500;
